import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface SecondaryButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'outlined' | 'text';
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({ 
  children, 
  variant = 'outlined',
  sx,
  ...props 
}) => {
  const buttonSx: SxProps<Theme> = {
    textTransform: 'none',
    fontWeight: 500,
    borderRadius: '4px',
    minHeight: '36px',
    px: 2,
    py: 1,
    transition: 'all 0.2s ease-in-out',
    color: 'text.primary',
    borderColor: (theme) => theme.palette.grey[400],
    borderWidth: '1px',
    borderStyle: 'solid',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'action.hover',
      borderWidth: '1px',
    },
    '&:focus': {
      borderColor: 'primary.main',
      borderWidth: '1px',
    },
    ...sx,
  };

  return (
    <Button
      variant={variant}
      sx={buttonSx}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;